import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
const partyvalidate = (customer_name)=>{
  return axios.post(API + "parties/partyvalidate/",{
   
    customer_name,
  },{headers: authHeader(),})
}
const addParty = (customer_type, party_type, customer_name,establishment_date, sales_tax_code,TIN_number,website,prefix,first_name,middle_name,last_name,ssn_tin_number,id_number,id_issue_state,date_of_birth,extrafiledparty,consolidate_invoice,pre_bill_days,generate_invoice,
  doingBusinessAs,
  business_type,
  federalID,
  SIC,
  NAICS,
  riskrating,
  creditscore,
  ACHPayments
) => {
  return axios.post(API + "parties/party-add/", {
    customer_type,
    party_type,
    customer_name,
    establishment_date,
    sales_tax_code,
    TIN_number,
    website,
    prefix,
    first_name,
    middle_name,
    last_name,
    ssn_tin_number,
    id_number,
    id_issue_state,
    date_of_birth,
    extrafiledparty,
    consolidate_invoice,
    pre_bill_days,
    generate_invoice,
    doingBusinessAs,
    business_type,
    federalID,
    SIC,
    NAICS,
    riskrating,
    creditscore,
    ACHPayments
  },{headers: authHeader(),});
};
const AddPartyService = {
    addParty,
    partyvalidate
  };
  export default AddPartyService;